export default __webpack_public_path__ + "static/media/digitalcard_ticket.8f1c0830.svg";